import SensitivitySelector from "./sensitivity-selector.vue";

export default SensitivitySelector;



// WEBPACK FOOTER //
// ./src/components/_sensitivity-selector/index.js